var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"observer",attrs:{"slim":""}},[_c('form',_vm._b({on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},'form',_vm.$props,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }